<header
  class="wrapper h-header-height w-full border-b border-surface bg-header"
>
  <nav class="section-padding-inline flex items-center">
    <a routerLink="/" class="shrink-0"
      ><img src="assets/noovi-logo.svg" class="h-10" alt="Logo"
    /></a>

    <div class="ml-16 hidden w-full justify-end md:flex">
      <!-- <div class="flex items-center">
        <ul class="flex gap-8">
          <li>
            <a
              [routerLink]="[AppRoutes.RESTAURANTS.ROOT]"
              pButton
              [rounded]="true"
              severity="secondary"
              [text]="true"
            >
              <span pButtonLabel>Explore Nearby Eats</span>
            </a>
          </li>
          <li>
            <a href="">Popular Near You</a>
          </li>
        </ul>
      </div> -->
      <div class="flex gap-4">
        <a
          [routerLink]="['/', AppRoutes.JOIN_PLATFORM]"
          pButton
          [rounded]="true"
          icon="pi pi-send"
          severity="secondary"
        >
          <span pButtonLabel>Join Our Platform</span>
        </a>
        <!-- <button class="btn btn-outline">Sign Up</button>
        <button class="btn">Log In</button> -->
      </div>
    </div>
  </nav>
</header>
<!-- Mobile navigation -->
<!-- <div
  class="fixed inset-0 top-header-height overflow-hidden"
  [ngClass]="isNavOpen() ? 'visible' : 'invisible'"
  (wheel)="preventScroll($event)"
  (touchmove)="preventScroll($event)"
>
  <div
    class="absolute inset-0 bg-(--p-mask-background) duration-300"
    [ngClass]="{
      'pointer-events-none opacity-0': !isNavOpen(),
    }"
    (click)="closeNav()"
  ></div>
  <div
    class="ease relative duration-250 -translate-y-full"
    [ngClass]="{
      'translate-y-0': isNavOpen(),
    }"
  >
    <div
      class="section-padding-inline py-section-padding shadow-xs border-surface rounded-b-3xl border-b bg-white"
    >
      <nav class="flex flex-col gap-4">
        <a
          routerLink="/"
          pButton
          [rounded]="true"
          icon="pi pi-send"
          severity="secondary"
          (click)="closeNav()"
          fluid
        >
          <span pButtonLabel>Join Our Platform</span>
        </a>
        <hr />
        <ul class="flex flex-col gap-8">
          <li>
            <a
              [routerLink]="[AppRoutes.RESTAURANTS.ROOT]"
              pButton
              [rounded]="true"
              severity="secondary"
              [text]="true"
              (click)="closeNav()"
              fluid
            >
              <span pButtonLabel>Explore Nearby Eats</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div> -->
